export const fiesta = () => {
  return [
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f1_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f1_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f1_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f1_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f9_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f9_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f9_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f9_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f7_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f7_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f7_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f7_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f10_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f10_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f10_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f10_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f2_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f2_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f2_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f2_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f3_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f3_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f3_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f3_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f4_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f4_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f4_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f4_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f6_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f6_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f6_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f6_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f5_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f5_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f5_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f5_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    },
    {
      default: {
        default: 'https://cdn.nohaypuntadasinhilo.com/f8_L.webp',
        sources: [
          { src: 'https://cdn.nohaypuntadasinhilo.com/f8_S.webp', media: '(max-width: 400px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f8_S.webp', media: '(max-width: 600px)' },
          { src: 'https://cdn.nohaypuntadasinhilo.com/f8_M.webp', media: '(max-width: 800px)' }
        ]
      },
      details: []
    }
  ]
}
